export enum PartnershipApplicationsActionTypes {
  RECEIVED = 'partnership-applications/RECEIVED',
  REQUEST = 'partnership-applications/REQUEST',
  NEXT_RECEIVED = 'partnership-applications/NEXT_RECEIVED',
  NEXT_REQUEST = 'partnership-applications/NEXT_REQUEST',
  REACT_SUCCESS = 'partnership-applications/REACT_SUCCESS',
  REACT_ERROR = 'partnership-applications/REACT_ERROR',
  REACT_REQUEST = 'partnership-applications/REACT_REQUEST',
}
